import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

const SpaceDefaultsPageRouteComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-SpaceDefaultsPageRouteComponent" */ './SpaceDefaultsPageRouteComponent.tsx'
		),
});

export const SpaceDefaultsPageRoute = () => <SpaceDefaultsPageRouteComponent />;

SpaceDefaultsPageRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'spaceDefaultsPermissionsScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
